/**
 * Wo der Kurzhinweis einer Zeile steht.
 *
 * Er schwebt über der Seite statt in der Zeile zu sitzen, und das ist keine Geschmacksfrage: Ein
 * Element *in* der Zeile legt sich zwischen den Zeiger und das, worauf geklickt wird. Genau daran
 * ist ein früherer Versuch gescheitert — die Zeile reagierte danach weder auf Überfahren noch auf
 * Klicks. Was außerhalb hängt und keine Zeigerereignisse annimmt, kann das nicht.
 *
 * Gerechnet wird gegen den sichtbaren Bereich, nicht gegen den Baum: Der Hinweis ist breiter als
 * die Spalte, in der der Baum steht, und würde an ihrem Rand sonst abgeschnitten.
 */

export interface Rect {
    top: number;
    bottom: number;
    left: number;
}

export interface Box {
    width: number;
    height: number;
}

export interface Viewport {
    width: number;
    height: number;
}

/** Abstand zwischen Zeile und Hinweis, und zum Rand des Fensters. */
const GAP = 6;
const MARGIN = 8;

/**
 * Unter der Zeile, sonst darüber.
 *
 * Unten ist die ruhigere Wahl — der Blick läuft ohnehin nach unten, und der Hinweis verdeckt nicht,
 * was man gerade liest. Nur wo unten kein Platz mehr ist, klappt er nach oben; ein Hinweis, der
 * halb unter dem Fensterrand steht, ist keiner.
 */
export const hintPlacement = (rect: Rect, box: Box, viewport: Viewport): { top: number; left: number } => {
    const below = rect.bottom + GAP;
    const fitsBelow = below + box.height + MARGIN <= viewport.height;

    const top = fitsBelow ? below : Math.max(MARGIN, rect.top - GAP - box.height);

    // Linksbündig zur Zeile, aber niemals über den rechten Rand hinaus. `Math.max` zuletzt, damit
    // ein Hinweis, der breiter ist als das Fenster, links anliegt statt links herauszuragen.
    const left = Math.max(MARGIN, Math.min(rect.left, viewport.width - box.width - MARGIN));

    return { top, left };
};
